import DOMHelper from '../reflection/DOMHelper';
import E from '../ui_core/E';
import eventEnable from '../core/eventEnable';
import getAbsoluteRectangle from '../ui_core/getAbsoluteRectangle';
import ElementAlignmentHelper  from '../ui_core/ElementAlignmentHelper';
import ButtonFactory from '../ui_factories/ButtonFactory';
import isNullOrUndefined from '../core/isNullOrUndefined';
import Side from '../enums/Side';
import './TutorialMessage.css';
export default class TutorialMessage{
	constructor({message, className, elementOn, buttons, hasClose, callbackClose, callbackPayload,
		left, top, fixInPlace,
		rightAlign}){
			eventEnable(this);
		this._disposes =[];
		this.dispose = this.dispose.bind(this);
		if(callbackPayload===undefined)
			callbackPayload = this;
		this._element = E.div('tutorial-message');
		if(className)
			this._element.classList.add(className);
		const triangleElement = E.div('triangle');
		this._element.appendChild(triangleElement);
		this._callbackClose = callbackClose;
		if((!callbackClose)&&hasClose)
			callbackClose = this.dispose;
		if(elementOn){
			const setPosition = ElementAlignmentHelper.get_SetPositionRelativeToOtherElement(this._element, rightAlign);
			setTimeout(()=>{
				setPosition(elementOn);
			}, 0);
			if(!fixInPlace)
				this._intervalSetPosition = setInterval(()=>{
					setPosition(elementOn);
					//if(elementOn.offsetLeft<=0||elementOn.offsetTop<=0)
						//elementOn.style.display='none';
				}, 30);
		}
		else{
			this._element.style.left=left?(typeof(left)==='number'?`${left}px`:left):'50%';
			this._element.style.top=top?(typeof(top)==='number'?`${top}px`:top):'50%';
			this._element.style.transform = 'translate(-50%,-50%)';
		}
		if(callbackClose){
			const closeButton = ButtonFactory.close('close-button', callbackClose, this._disposes);
			this._element.appendChild(closeButton);
		}
		this._messageElement = E.div('message');
		this._messageElement.textContent = message;
		this._element.appendChild(this._messageElement);
		if(buttons&&buttons.length>0){
			this._buttonsElement = E.div('buttons');
			this._element.appendChild(this._buttonsElement);
			for(var button of buttons){
				const buttonElement = E.button('button');
				const {text, callback}=button;
				const callbackWithPayload = ()=>callback(callbackPayload);
				buttonElement.addEventListener('click', callbackWithPayload);
				buttonElement.textContent = text;
				this._disposes.push(()=>{
					buttonElement.removeEventListener('click', callbackWithPayload);
				});
				this._buttonsElement.appendChild(buttonElement);
			}
			
		}
		document.body.appendChild(this._element);
		TutorialMessage._instances.push(this);
	}
	static closeAll(){
		TutorialMessage._instances.forEach(tutorialMessage=>tutorialMessage.close());
	}
	get disposed(){
		return this._disposed?true:false;
	}
	close(){
		this.dispose();
		this._callbackClose&&this._callbackClose();
	}
	dispose(){
		const index = TutorialMessage._instances.indexOf(this);
		if(index>=0)
			TutorialMessage._instances.splice(index, 1);
		this._disposed = true;
		if(this._intervalSetPosition)
			clearInterval(this._intervalSetPosition);
		this._intervalSetPosition = null;
		this._disposes.forEach(d=>d());
		if(this._element.parentElement)
			this._element.parentElement.removeChild(this._element);
		this.dispatchEvent({type:'dispose', tutorialMessage:this});
	}
}
TutorialMessage._instances=[];